<template>
  <div style="text-align: center;display: flex;flex-direction: column;align-items: center;width: 100%;padding-top: 20px;">
    <!-- 用户头像区域 -->
    <div class="avatar-container">
      <el-avatar :size="100" :src="avatarUrl" @error="handleAvatarError" v-if="isLoad">
        <img src="../assets/img/logo.png"/>
      </el-avatar>
      <div class="avatar-actions">
        <el-upload
          class="avatar-uploader"
          action="#"
          :http-request="uploadAvatar"
          :show-file-list="false"
          accept="image/*">
          <el-button size="small" type="primary" icon="el-icon-upload">{{ avatarUrl ? '修改头像' : '上传头像' }}</el-button>
        </el-upload>
      </div>
    </div>
    
    <h2>你好 {{ userInfo.realName }}</h2>
    <div>
      <h3>
        用户级别：
        <el-tag v-if="userInfo.userLevel === 1" effect="dark" type="danger">运营端</el-tag>
        <el-tag v-else-if="userInfo.userLevel === 2" effect="dark" type="info">诊所端</el-tag>
        <el-tag v-else-if="userInfo.userLevel === 3" effect="dark" type="success">医生端</el-tag>
        <el-tag v-else>未知</el-tag>
      </h3>
    </div>

    <el-form :model="passForm" status-icon :rules="rules" ref="passForm" label-width="100px">
      <el-form-item label="旧密码" prop="oldPassword">
        <el-input type="Password" v-model="passForm.oldPassword" autocomplete="off" clearable></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input type="Password" v-model="passForm.newPassword" autocomplete="off" clearable></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input type="Password" v-model="passForm.checkPass" autocomplete="off" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="submitForm('passForm')" icon="el-icon-check">提交</el-button>
        <el-button type="info" @click="resetForm('passForm')" icon="el-icon-close">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

export default {
  name: "UserCenter",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.passForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      userInfo: {},
      avatarUrl: '',
      avatarBlob: null, // 存储Blob对象引用
      isLoad: false,
      passForm: {
        oldPassword: '',
        newPassword: '',
        currentPass: ''
      },
      rules: {
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
        ],
        checkPass: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        currentPass: [
          { required: true, message: '请输入当前密码', trigger: 'blur' },
        ]
      }
    }
  },
  created() {
    this.getUserInfo()
    this.getAvatarThumbnail()
  },
  beforeDestroy() {
    // 组件销毁前释放Blob URL，防止内存泄漏
    if (this.avatarUrl) {
      URL.revokeObjectURL(this.avatarUrl)
    }
  },
  methods: {
    getUserInfo() {
      // this.$axios.get("/userCenter/userInfo").then(res => {
      //
      //   this.userInfo = res.data.data;
      // })
      let user = JSON.parse(sessionStorage.getItem("User"));
      this.userInfo = user
    },
    // 获取用户头像缩略图
    getAvatarThumbnail() {
      // 导入api中的getBlob方法
      const { getBlob } = require('@/api/api')
      this.isLoad = false
      // 添加时间戳参数避免缓存
      getBlob(`/personalCenter/thumbnail?t=${Date.now()}`).then(res => {
        // 创建Blob URL
        this.isLoad = false
        const blob = new Blob([res.data], { type: res.headers['content-type'] })
        this.avatarUrl = URL.createObjectURL(blob)
        this.isLoad = true
        this.$forceUpdate()
      }).catch(err => {
        console.error('获取头像失败', err)
      })
    },
    // 处理头像加载错误
    handleAvatarError() {
      console.log('头像加载失败，使用默认头像')
    },
    // 上传头像
    uploadAvatar(options) {
      const formData = new FormData()
      formData.append('file', options.file)
      
      // 使用api中的post方法
      const { post } = require('@/api/api')
      
      post('/personalCenter/uploadImg', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.$message.success('头像上传成功')
          
          // 先释放之前的Blob URL，防止内存泄漏
          if (this.avatarUrl) {
            URL.revokeObjectURL(this.avatarUrl)
            this.avatarUrl = ''
          }
          
          // 重新获取头像
          this.getAvatarThumbnail()
        } else {
          this.$message.error(res.data.msg || '头像上传失败')
        }
      }).catch(err => {
        console.error('上传头像失败', err)
        this.$message.error('上传头像失败')
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          const _this = this
          this.$axios.post('/homepage/changePassword', {
              oldPassword: this.passForm.oldPassword,
              newPassword: this.passForm.newPassword
          }).then(res => {
            if (res.data.code === 200) {
              this.$message.success('修改成功！请重新登录')
              // 清除用户信息和路由状态，确保重新登录时重新加载菜单
              sessionStorage.removeItem("User");
              sessionStorage.removeItem("hasRoute");
              // 重置store中的路由状态
              this.$store.commit("changeRouteStatus", false);
              this.$router.replace("/login");
            } else {
              this.$message.error(res.data.msg);
            }
          })
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scoped>
.avatar-container {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.avatar-actions {
  margin-top: 10px;
}

.avatar-uploader {
  display: inline-block;
}
.el-form {
  width: 420px;
  margin: 50px auto;
}
</style>
